import { renderBooleanIcon } from '../utility/dictionaryGridHelper';

export const DEFAULT_DICTIONARY_PERMISSIONS = {
  Create: false,
  Read: true,
  Edit: false,
  Delete: false,
  ViewDeleted: false,
};

export const DEFAULT_VALUES = {
  ROWGUID: null,
  Code: '',
  Description: '',
  Category: '',
  IsDefault: false,
  IsActive: true,
};

export const DICTIONARY_GRID_COLUMNS = [
  { field: 'Code', title: 'Code' },
  { field: 'Description', title: 'Description' },
  { field: 'Category', title: 'Category' },
  { field: 'IsDefault', title: 'Is Default', render: renderBooleanIcon },
  { field: 'IsActive', title: 'Is Active', render: renderBooleanIcon },
];
